import { OnsiteInterviewListAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

/**
 * Fetches onsite interview list and transforms to entity list
 *
 * @param {import('../types/OnsiteInterviewList.parameters').IGetOnsiteInterviewListPayload} payload - Request payload
 * @returns {Promise<{ data: import('../types/OnsiteInterviewList').IOnsiteInterviewEntity[], page: number, limit: number, total: number }>} Onsite interview entity list with pagination
 */
export const getOnsiteInterviewList = async ({
  postingId,
  page,
  limit,
  orderBy,
  orderDirection,
  status,
  professionalId,
}) => {
  const response = await PermanentJobsApi.getOnsiteInterviewList({
    postingId,
    page,
    limit,
    orderBy,
    orderDirection,
    status,
    professionalId,
  });

  return OnsiteInterviewListAdapters.toOnsiteInterviewListResponse(response);
};
